import { message } from "antd";
import axiosInstance from "../shared/axios";

// GET SESSIONS WITH PAGINATION + FILTERS
const getSessionsAll = async (params) => {
  try {
    const result = await axiosInstance.get("/sessions/viewAll", {
      params: {
        startDate: params?.startDate || "",
        endDate: params?.endDate || "",
        name: params?.name || "",
        serviceID: params?.serviceID || "",
        status: params?.status || "",
        pageNo: params?.pageNo || 1,
        recordsPerPage: params?.recordsPerPage || 10,
      },
    });

    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading sessions");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading sessions",
    );
    return { data: [], total: 0 };
  }
};

const getTemplateMedicineLookUp = async (id) => {
  try {
    let result = await axiosInstance.get(
      `/sessions/getTemplateMedicines/${id}`,
    );
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("error", "Error while loading template medicines");
      return null;
    }
  } catch (error) {
    message.error("error", "Error while loading template medicines");
    return null;
  }
};

const getClientSessionDetail = async (id) => {
  try {
    let result = await axiosInstance?.get(`/sessions/details/${id}`);
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("error", "Error while loading client session detail");
      return null;
    }
  } catch (error) {
    message.error("error", "Error while loading client session detail");
    return null;
  }
};

const getAllSessionsDateTime = async (id) => {
  try {
    let result = await axiosInstance?.get(`/sessions/nextSession/${id}`);
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      // message.error(result?.data?.message || "Error while loading session");
      return null;
    }
  } catch (error) {
    // message.error(error || "error", "Error while loading session");
    console.log(error);
    return null;
  }
};

const getViewSessionPrescription = async ({ id, templateID }) => {
  try {
    let result = await axiosInstance?.get(
      `/sessions/viewSessionPrescreptions`,
      {
        params: {
          sessionID: id,
          templateID: templateID,
        },
      },
    );
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("error", "Error while loading view session prescription");
      return null;
    }
  } catch (error) {
    message.error("error", "Error while loading view session prescription");
    return null;
  }
};

const addEditSessionTemplatePrescription = async (
  payload,
  tempId,
  sessionId,
  id,
) => {
  try {
    const result = await axiosInstance.post(
      id ? "/client-prescription/update" : "/client-prescription/create",
      {
        ...payload,
        templateID: tempId,
        sessionID: sessionId || null,
        id: id || null,
      },
    );
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save medicines",
    };
  }
};

const addSessionTemplatePrescription = async (payload, tempId, sessionId) => {
  try {
    const result = await axiosInstance.post("/client-prescription/create", {
      ...payload,
      templateID: tempId,
      sessionID: sessionId || null,
    });
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save medicines",
    };
  }
};

const updateSessionStatus = async ({ id, status }) => {
  try {
    let result = await axiosInstance?.patch(`/sessions/updateStatus`, {
      id,
      status,
    });
    if (result?.status === 200 && result?.data?.success) {
      return result?.data;
    } else {
      message.error("error", "Error while loading update session status");
      return null;
    }
  } catch (error) {
    message.error("error", "Error while loading update session status");
    return null;
  }
};

const deleteSession = async (id) => {
  try {
    const result = await axiosInstance.delete(`/sessions/delete/${id}`);

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete session",
    };
  }
};

export const sessionapi = {
  getSessionsAll,
  getTemplateMedicineLookUp,
  getClientSessionDetail,
  getViewSessionPrescription,
  addEditSessionTemplatePrescription,
  addSessionTemplatePrescription,
  updateSessionStatus,
  deleteSession,
  getAllSessionsDateTime,
};
